import { useEffect, useState } from "react";
import { parseMacroData } from "../helpers/parsers";
import { MACRO_KEY } from "../optics/defaults";

export const useMacroData = () => {
  const [data, setData] = useState();

  useEffect(() => {
    const loadData = () => {
      window.AP.confluence.getMacroData((macroData) => {
        if (!Object.keys(macroData || {}).length) {
          setData(undefined);
          return;
        }

        try {
          if (macroData.macro === MACRO_KEY.CARDS) {
            setData({
              data: JSON.parse(macroData.data),
              macro: MACRO_KEY.CARDS,
            });
          } else {
            const data = parseMacroData({ data: macroData });
            setData(data);
          }
        } catch (error) {
          console.log("error", error);
        }
      });
    };

    loadData();
  }, []);

  return data;
};
